import * as React from 'react';
import CommonComplaintsPage from "./CommonComplaintsPage";

export class ComplaintsPage extends React.Component {

    public render() {
        return <CommonComplaintsPage/>;
    }
}
